
  import {computed, defineComponent, onMounted, PropType, reactive, SetupContext, toRefs, watch} from "vue";
  import Employee from "@/model/Employee";
  import FormDatePickerV2 from "@/components/FormDatePickerV2.vue";
  import {earliestValidFrom} from "@/store/StoreUtils";
  import {today} from "@/DateUtils";
  import CompanyLocationService, {CompanyLocationV2Dto} from "@/service/CompanyLocationService";
  import LocationUtils from "@/views/Inventories/InventoriesCompanyLocations/LocationUtils";

  export default defineComponent({
    name: "EmployeePersonalForm",
    components: {
      FormDatePickerV2
    },
    props: {
      employee: {
        type: Object as PropType<Employee>,
        default: () => new Employee()
      },
      errors: {
        type: Map as PropType<Map<string, string>>,
        default: () => new Map<string, string>()
      }
    },
    setup(props, context: SetupContext) {
      const initialState = {
        // This is a hack where we directly mutate a prop, but since this form is tightly coupled with the main employee
        // model in the parent classes
        model: props.employee,
        companyLocations: null as Array<CompanyLocationV2Dto> | null
      };

      const state = reactive({...initialState});

      onMounted(() => {
        loadCompanyLocations();
      });

      const loadCompanyLocations = () => {
        if (state.companyLocations == null) {
          CompanyLocationService.findCompanyLocations()
            .then(companyLocations => {
              state.companyLocations = companyLocations;
            });
        }
      };

      // The employee endpoints reference the company location by its uuid, which is the v2 location's id
      const companyLocationId = computed({
        get(): string | null {
          return state.model.companyLocation?.uuid ?? null;
        },
        set(id: string | null) {
          const companyLocation = state.companyLocations?.find(location => location.id === id);
          state.model.companyLocation = companyLocation ? {uuid: companyLocation.id, name: companyLocation.name} : null;
        }
      });

      const filterCompanyLocation = (item: CompanyLocationV2Dto, queryText: string) => {
        const text = `${item.name} ${LocationUtils.toAddressString(item)}`.toLowerCase();
        return text.includes(queryText.toLowerCase());
      };

      const showBirthdayPicker = computed(() => {
        return !state.model.birthdate;
      });

      watch(() => props.employee, (newValue) => {
        state.model = newValue;
      });

      return {
        ...toRefs(state),
        companyLocationId,
        earliestValidFrom,
        filterCompanyLocation,
        showBirthdayPicker,
        toAddressString: LocationUtils.toAddressString,
        today
      };
    }
  });
